// extracted by mini-css-extract-plugin
export default {"index":"audit-logs_index__pMjgU","body":"audit-logs_body__TgjR8","toolbar":"audit-logs_toolbar__VXjhW"};